import type {ContainerProps as MaterialContainerProps} from '@mui/material/Container';
import MaterialContainer from '@mui/material/Container';
import {styled} from '@mui/material/styles';
import React from 'react';

export type ContainerProps = MaterialContainerProps;

const StyledContainer = styled(MaterialContainer)<ContainerProps>(({
    theme, disableGutters
}) => ({
    paddingLeft: '1rem',
    paddingRight: '1rem',

    [theme.breakpoints.up('sm')]: {
        paddingLeft: '1rem',
        paddingRight: '1rem'
    },

    ...disableGutters && {
        paddingLeft: 0,
        paddingRight: 0
    }
}));

export const Container = React.forwardRef<HTMLDivElement, ContainerProps>(({
    children, ...props
}, ref) => {
    return (
        <StyledContainer
            ref={ref}
            {...props}
        >
            {children}
        </StyledContainer>
    );
});

Container.displayName = 'Container';
